export default __webpack_public_path__ + "static/media/013-spray.27d31979.svg";